
import { shuffle, uniqBy } from 'lodash'
import { stickyHeader } from '@/Utils/directives'
// import SuggestionTemplate from '@/components/Search/Suggestions/SuggestionTemplate.vue'

export default {
    name: 'SuggestionsTemplates',
    components: { },
    directives: { stickyHeader },
    props: {
        categories: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            filter: null
        }
    },
    computed: {
        items () {
            let items = []
            for (const category of this.categories) {
                if (this.filter !== null && category.id !== this.filter) { continue }
                items = items.concat(category.suggestions.map(item => ({ suggestion: item, category })))
            }
            return shuffle(uniqBy(items, item => item.suggestion.id))
        }
    }
}
